package one.healthium.login.di

import org.koin.dsl.module

val loginUiModule = module {
    includes(loginModule)
}